/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceConnectorUptimeResponse
 */
export interface DeviceConnectorUptimeResponse {
    /**
     * The index of the connector
     * @type {number}
     * @memberof DeviceConnectorUptimeResponse
     */
    connectorIndex?: number;
    /**
     * The uptime of the connector. Offline periods are not considered in the availability calculation. i.e., device assumed to be continuously online.
     * @type {number}
     * @memberof DeviceConnectorUptimeResponse
     */
    uptimeOfflineIncluded?: number;
    /**
     * The uptime of the connector. Offline periods are removed from the availability calculation.
     * @type {number}
     * @memberof DeviceConnectorUptimeResponse
     */
    uptimeOfflineExcluded?: number;
    /**
     * The preferred uptime value based on organisation preference. Defaults to UptimeOfflineIncluded if preference not set.
     * @type {number}
     * @memberof DeviceConnectorUptimeResponse
     */
    preferredUptime?: number;
    /**
     * Indicates which calculation method was used for PreferredUptime. true = offline included, false = offline excluded.
     * @type {boolean}
     * @memberof DeviceConnectorUptimeResponse
     */
    isOfflineIncluded?: boolean;
}

/**
 * Check if a given object implements the DeviceConnectorUptimeResponse interface.
 */
export function instanceOfDeviceConnectorUptimeResponse(
    value: object,
): value is DeviceConnectorUptimeResponse {
    return true;
}

export function DeviceConnectorUptimeResponseFromJSON(
    json: any,
): DeviceConnectorUptimeResponse {
    return DeviceConnectorUptimeResponseFromJSONTyped(json, false);
}

export function DeviceConnectorUptimeResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceConnectorUptimeResponse {
    if (json == null) {
        return json;
    }
    return {
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        uptimeOfflineIncluded:
            json["uptimeOfflineIncluded"] == null
                ? undefined
                : json["uptimeOfflineIncluded"],
        uptimeOfflineExcluded:
            json["uptimeOfflineExcluded"] == null
                ? undefined
                : json["uptimeOfflineExcluded"],
        preferredUptime:
            json["preferredUptime"] == null
                ? undefined
                : json["preferredUptime"],
        isOfflineIncluded:
            json["isOfflineIncluded"] == null
                ? undefined
                : json["isOfflineIncluded"],
    };
}

export function DeviceConnectorUptimeResponseToJSON(
    value?: DeviceConnectorUptimeResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        connectorIndex: value["connectorIndex"],
        uptimeOfflineIncluded: value["uptimeOfflineIncluded"],
        uptimeOfflineExcluded: value["uptimeOfflineExcluded"],
        preferredUptime: value["preferredUptime"],
        isOfflineIncluded: value["isOfflineIncluded"],
    };
}
